



































import { defineComponent } from '@vue/composition-api'
import accessibility from '~/utils/solepro/accessibility';

export default defineComponent({
    props: {
        modalContent: { type: Object },
        modalRef: { type: Number },
        uniqueId: { type: String },
        resetEvidence: { type: Function },
        buttonRefs: { 
            //validator: (prop) => prop instanceof HTMLButtonElement || typeof prop === "object",
         },
        isTutorial:{type: Boolean, default: false},
        title:{
            type: String
        }
    },
    data(){
     return{
        selectedElement: null,
        overlay: null,
     }
    },
    setup(props) {
        return {
            modalTitleId :props.title ? props.title.match(/[a-zA-z0-9]/g)?.join():'Testimonianza'
        }
    },
    mounted() {
        this.selectedElement = this.buttonRefs;
        this.overlay = document.getElementById('modal-backdrop');
        //const modal = document.querySelector(this.selectedElement.dataset.target);
        this.selectedElement.addEventListener("click", (e) => {
            this.openModal()
        });

        this.overlay.addEventListener("click", (e)=>{
            this.closeModal(e)
        })

        accessibility.accessibleModal(this.selectedElement);

    },
    methods: {
        getBgImage(jsonString) {
            const images = JSON.parse(jsonString.replaceAll('\\', ''));
            return images.desktop_image
        },
        openModal() {
            // Add overlay before modal
            const modal = document.querySelector(this.selectedElement.dataset.target);
            this.overlay.classList.remove('hidden');
            document.body.classList.add('modal-open');
            // Show modal
            setTimeout(function () {
                modal.classList.add('show');
                accessibility.simpleFocusTrap(modal as HTMLElement)
            }, 500);
            
        },
        closeModal(e) {
            const modal = document.querySelector(this.selectedElement.dataset.target);
            const iframe = modal.querySelector('iframe');
            modal.classList.remove('show');
            this.overlay.classList.add('hidden'); 
            document.body.classList.remove('modal-open');

            if (iframe) {
                const src = iframe.getAttribute('src');
                iframe.setAttribute('src', '')
                iframe.setAttribute('src', src)
            }
            this.resetEvidence();
        },
        isBackgroundImage(slide) {
            return slide.bannerDatas.backgroundType == "image";
        },
        isVideoImage(slide) {
            return slide.bannerDatas.backgroundType == "video";
        }
    }
})
